import React, { useEffect, useMemo, useState } from 'react';
import { normalizeSocialPlatform } from '../../../common/enums/socialPlatforms';
import douyinNormalIcon from '../../assets/images/douyin-normal.png';
import kuaishouNormalIcon from '../../assets/images/kuaishou-normal.png';
import xhsNormalIcon from '../../assets/images/xhs-normal.png';
import insNormalIcon from '../../assets/images/ins-normal.png';
import './PlatformAvatar.css';

interface PlatformAvatarProps {
  src?: string | null;
  platform?: string | null;
  size?: number;
  alt?: string;
  className?: string;
}

const DEFAULT_AVATAR_SIZE = 24;

function getPlatformAvatarIcon(platform?: string | null) {
  switch (normalizeSocialPlatform(platform)) {
    case 'kuaishou':
      return kuaishouNormalIcon;
    case 'xiaohongshu':
      return xhsNormalIcon;
    case 'instagram':
      return insNormalIcon;
    case 'tiktok':
      return douyinNormalIcon;
    case 'douyin':
    default:
      return douyinNormalIcon;
  }
}

export const PlatformAvatar: React.FC<PlatformAvatarProps> = ({
  src,
  platform,
  size = DEFAULT_AVATAR_SIZE,
  alt = '',
  className = '',
}) => {
  const [imageStatus, setImageStatus] = useState<'loading' | 'loaded' | 'error'>(src ? 'loading' : 'error');

  useEffect(() => {
    setImageStatus(src ? 'loading' : 'error');
  }, [src]);

  const fallbackIconUrl = useMemo(() => getPlatformAvatarIcon(platform), [platform]);
  const iconSize = Math.max(Math.round(size * 0.58), 10);
  const rootClassName = className
    ? `platform-avatar ${className}`
    : 'platform-avatar';

  return (
    <span
      className={rootClassName}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
    >
      <img
        src={fallbackIconUrl}
        alt=""
        aria-hidden="true"
        className="platform-avatar__fallback-icon"
        style={{ width: iconSize, height: iconSize }}
      />
      {src && imageStatus !== 'error' ? (
        <img
          src={src}
          alt={alt}
          className={`platform-avatar__image${imageStatus === 'loaded' ? ' platform-avatar__image--loaded' : ''}`}
          onLoad={() => setImageStatus('loaded')}
          onError={() => setImageStatus('error')}
        />
      ) : null}
    </span>
  );
};

export default PlatformAvatar;
